import { Avatar, Box, Text } from '@factorialco/deprecated-design-system'
import {
  FilterType,
  buildDocumentsDataTableFilter,
  useDocumentsDataTable,
} from 'generated/resources/datatable.graphql'

import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

export interface AccessData {
  id: string
  fullName: string
  avatar?: string | null
}

interface NameWithAvatarProps {
  fullName: string
  avatar?: string | null
}

const NameWithAvatar = ({ fullName, avatar }: NameWithAvatarProps) => (
  <Box gap="s8" flexDirection="row" alignItems="center">
    <Avatar label={fullName} url={avatar ? buildUrl(avatar) : undefined} size="s32" />
    <Text.Normal>{fullName}</Text.Normal>
  </Box>
)

const deletedByFilter = (
  source: ReturnType<typeof useDocumentsDataTable>,
  accesses: AccessData[]
) => {
  const options = accesses
    .map((access) => ({
      label: access.fullName,
      value: access.id,
      component: <NameWithAvatar fullName={access.fullName} avatar={access.avatar} />,
    }))
    .sort((a, b) => a.label.localeCompare(b.label))

  return buildDocumentsDataTableFilter(source, {
    type: FilterType.Id,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options,
      },
    ],
    identifier: 'deleted_by_id',
    path: 'deletedBy',
    title: i18n.t('documents.employee.filters.deleted_by'),
  })
}

export default deletedByFilter
